import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'PLN',
    enableEnergyLabelLink: true,
};
